import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';
import {ConfirmedComponent} from 'components/atoms/tooltip/confirmed-component';
import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import BasePlayerBuilder from 'components/organisms/players-to-exchange/available-players/base-player-builder';

export default class DefaultBuilder extends BasePlayerBuilder implements BuilderInterface {
    getTableHead(): Array<TableElement> {
        const elements = {
            'td-pos': 'Pos',
            'td-name': 'Name',
            'td-confirm': 'Confirmed',
            'narrow-th': 'Order',
            'td-team': 'Team',
            'td-opponent': 'Opponent',
            'td-hand': 'Hand',
            'td-rating': 'Rating',
            'td-salary': 'Salary',
            'td-fpts-per-salary': 'Fpts/$',
            'td-fpts': 'Fpts',
            'td-pown': 'pOwn%',
            '': '',
        };

        return this.buildRow(elements);
    }

    getTableBody(
        player: PlayerInterface,
        substitutablePlayer: PlayerInterface,
        lineup: LineupInterface,
        salaryCapExceeded: boolean,
    ): Array<TableElement> {
        const elements = {
            'td-pos': player.positionName,
            'td-name': player.name,
            'td-confirm': <ConfirmedComponent player={player} />,
            'narrow-th': player.order ? `#${player.order}` : '',
            'td-team': <TeamLogo teamName={player.team} />,
            'td-opponent': <TeamLogo teamName={player.opponent} />,
            'td-hand': player.getPropValue('hand'),
            'td-rating': player.grades,
            'td-salary': player.getSalaryByMode(),
            'td-fpts-per-salary': player.getFptsPerSalary(),
            'td-fpts': player.getUserPointsByMode(),
            'td-pown': player.projOwn.getValue(player.mode),
            '': this.getSwapButton(salaryCapExceeded, substitutablePlayer, player, lineup),
        };

        return this.buildRow(elements);
    }
}
